<template>
    <d-container fluid class="main-content-container px-4">
        <div class="page-header row no-gutters py-4">
            <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                <h3 class="page-title">Connect Integration</h3>
            </div>
        </div>

        <div v-if="checkPermission(permissionTypes.integrationWrite)">
            <d-row>
                <d-col lg="12">
                    <d-card
                        class="card-small card-post card-post--aside card-post--1"
                    >
                        <d-card-body>
                            <h6>Connect your Integrations</h6>
                            <p>
                                Integrate Ivanhoe with your services like Google
                                Analytics. After a succesful integration you
                                will see the future transactions showing up in
                                the integration you connected with us.
                            </p>
                            <d-link
                                tag="button"
                                :to="{ name: 'network' }"
                                class="btn btn-success"
                                >Finish</d-link
                            >
                        </d-card-body>
                    </d-card>
                </d-col>
            </d-row>
            <d-row class="mt-3">
                <d-col class="mb-4" lg="4" v-if="googleAnalytics && googleAnalyticsIsReady">
                    <ga
                        :config="googleAnalytics"
                        :hasGoogleConnection="hasGoogleConnection"
                    />
                </d-col>
                <d-col class="mb-4" lg="4">
                    <gaV4 :config="googleAnalyticsV4" />
                </d-col>
                <d-col class="mb-4" lg="4">
                    <ba :bing-ads="bingAds" />
                </d-col>
                <d-col class="mb-4" lg="4">
                    <facebook-integration :facebook="facebook" />
                </d-col>
                <d-col class="mb-4" lg="4" v-if="this.userInfo.email === 'geert@keuze.nl'">
                    <keuzenl-integration :keuze="keuzeNLIntegration" />
                </d-col>
                <d-col class="mb-4" lg="4" v-if="this.userInfo.email === 'bart@risk.nl'">
                    <kizi-integration :kizi="kiziNLIntegration" />
                </d-col>
                <d-col class="mb-4" lg="4">
                    <kickbite-integration :kickbite="kickbiteIntegration" />
                </d-col>
            </d-row>
        </div>
        <no-permission-message v-else />
    </d-container>
</template>

<script>
import BingAds from "./bing-ads/connect.vue";
import GoogleAnalytics from "./google-analytics/connect.vue";
import GoogleAnalyticsV4 from "../../components/integrations/google-analytics-v4/Component.vue";
import facebookIntegration from "./facebook/connect.vue";
import keuzeNLIntegration from "./keuze/connect.vue";
import kiziNLIntegration from "./kizi/connect.vue";
import kickbiteIntegration from "./kickbite/connect.vue";
import { WebsiteService } from "@/main";
import permissions from "../../mixins/permissions";

export default {
    mixins: [permissions],

    components: {
        ga: GoogleAnalytics,
        gaV4: GoogleAnalyticsV4,
        ba: BingAds,
        facebookIntegration,
        'keuzenl-integration': keuzeNLIntegration,
        'kizi-integration': kiziNLIntegration,
        'kickbite-integration': kickbiteIntegration
    },

    data() {
        return {
            googleAnalytics: null,
            googleAnalyticsV4: null,
            googleOAuth: null,
            bingAds: null,
            facebook: null,
            hasGoogleConnection: null,
            googleAnalyticsIsReady: false,
            keuzeNLIntegration: null,
            kiziNLIntegration: null,
            kickbiteIntegration: null,
        };
    },

    methods: {
        async getWebsite() {
            try {
                const website = await WebsiteService.getById(
                    this.$route.params.id
                );
                this.googleAnalytics = website.googleAnalyticsIntegration;
                this.googleAnalyticsV4 = website.googleAnalyticsV4Integration;
                this.bingAds = website.bingAdsIntegration;
                this.facebook = website.facebookIntegration;
                this.hasGoogleConnection = website.hasGoogleConnection;
                this.googleAnalyticsIsReady = true;
                this.keuzeNLIntegration = website.hasKeuzeNLConnection;
                this.kiziNLIntegration = website.hasKiziNLConnection;
                this.kickbiteIntegration = website.kickbiteIntegration;
            } catch (e) {
                console.log(e);
                return false;
            }
        }
    },

    computed: {
        userInfo() {
            return this.$store.getters.userInfo
        },
    },

    created() {
        $cookies.set("website_id", this.$route.params.id);
        this.getWebsite();
    }
};
</script>
